import { useQuery } from "@tanstack/react-query";
import { ArchiveClusterArchives } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
export const ARCHIVE_INDICES_SUMMARY_QUERY_KEY = "archiveIndicesSummary";
const fetchIndicesSummary = async () => ArchiveClusterArchives.indicesSummary();
const useArchiveIndicesSummary = () => useQuery({
  queryKey: [ARCHIVE_INDICES_SUMMARY_QUERY_KEY],
  queryFn: () => defaultOnError(fetchIndicesSummary(), "Loading index summary failed with status"),
  retry: 0
});
export default useArchiveIndicesSummary;
